import { render } from "./language-switch.vue?vue&type=template&id=e2ba4f9c"
import script from "./language-switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./language-switch.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "e2ba4f9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2ba4f9c', script)) {
    api.reload('e2ba4f9c', script)
  }
  
  module.hot.accept("./language-switch.vue?vue&type=template&id=e2ba4f9c", () => {
    api.rerender('e2ba4f9c', render)
  })

}

script.__file = "resources/ts/components/elements/language-switch.vue"

export default script